package com.havn.app.core.supabase

actual val havnEnvironmentName: String = "production"
actual val havnSupabaseUrl: String = "https://api.havnre.app"
actual val havnSupabasePublishableKey: String = "sb_publishable_H4I_iyqSUU4YPtO3kw0xNA_3IAZQkjm"
actual val havnAppReviewEmail: String = "appreview85888@appreview_havn.test"
actual val havnAppReviewCode: String = "96955986"
actual val havnRevenueCatApiKey: String = ""
actual val havnRevenueCatWebPurchaseLink: String = "https://pay.rev.cat/qfcqqkgkufrljgtf/"
actual val havnRevenueCatWebSoloMonthlyPackageId: String = "\$rc_custom_solo_monthly"
actual val havnRevenueCatWebSoloYearlyPackageId: String = "\$rc_custom_solo_yearly"
actual val havnRevenueCatWebProMonthlyPackageId: String = "\$rc_custom_pro_monthly"
actual val havnRevenueCatWebProYearlyPackageId: String = "\$rc_custom_pro_yearly"
actual val havnRevenueCatWebTeamMonthlyPackageId: String = "\$rc_custom_team_monthly"
actual val havnRevenueCatWebTeamYearlyPackageId: String = "\$rc_custom_team_yearly"
actual val havnMapKitJsToken: String = "eyJraWQiOiJUWEY0UFUyRDlGIiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJOV0FXU1c3VUhHIiwiaWF0IjoxNzgwNTU1MTQ2LCJvcmlnaW4iOiIqLmhhdm5yZS5hcHAiLCJzY29wZSI6Im1hcGtpdF9qcyJ9.cFCQYb4zaHySV0RPOUOsPPNVX8cELiQ7pG8RRrK5kHoYBBz3xQ-11PfyE0jK9-OX-_pB3sYtcdZQR76DEGWgoQ"
